import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-email-input',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './email-input.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EmailInputComponent),
    multi: true,
  }]
})
export class EmailInputComponent implements ControlValueAccessor {
  @Input() confirm: boolean;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() isValid = true;
  @Input() errorMessage?: string;
  @Output() didChange = new EventEmitter<string>();

  value = '';
  confirmValue?: string;
  id = '' + Math.random();
  caption?: string = undefined;

  onChange = (value: any) => {};
  onTouched = () => {};

  inputHandler(event: Event) {
    const newValue = (event.target as HTMLInputElement).value;
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
  }

  blurHandler(event: FocusEvent) {
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onEmailChange(value: string) {
    this.value = value;
    this.onChange(value);
    this.didChange.emit(value);
  }

  onConfirmChange(value: string) {
    this.confirmValue = value;
  }
}
